import { render, staticRenderFns } from "./SpeechSetting.vue?vue&type=template&id=c535bfc0&"
import script from "./SpeechSetting.vue?vue&type=script&lang=ts&"
export * from "./SpeechSetting.vue?vue&type=script&lang=ts&"
import style0 from "./SpeechSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports